import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id D01B3C7C-64DC-4486-A656-55F7024C96AA
 * name sort-calendar-descending
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sort-calendar-descending.svg
 * tags
 * - Text / Content / Format 
 * - Date / Time 
 */
export const SortCalendarDescendingIcon = createSvgIcon(<><path d="M19 7H16L20 3L24 7H21V21H19V7M8 16H11V13H8V16M13 5H12V3H10V5H6V3H4V5H3C1.89 5 1 5.89 1 7V18C1 19.11 1.89 20 3 20H13C14.11 20 15 19.11 15 18V7C15 5.89 14.11 5 13 5M3 18L3 11H13L13 18L3 18Z" /></>, 'SortCalendarDescendingIcon');
export default SortCalendarDescendingIcon